import { createRouter, createWebHistory } from 'vue-router';

import SelectClinic from '../components/SelectClinic.vue';
import SelectTreatment from '../components/SelectTreatment.vue';
import SelectDateTime from '../components/SelectDateTime.vue';
import UserInfo from '../components/UserInfo.vue';
import ThankYou from '../components/ThankYou.vue';

const routes = [
  { path: '/cita-online/centro/', component: SelectClinic, name: 'Centro' },
  { path: '/cita-online/tratamiento/', component: SelectTreatment, name: 'Tratamiento' },
  { path: '/cita-online/cita/', component: SelectDateTime, name: 'Cita' },
  { path: '/cita-online/datos/', component: UserInfo, name: 'Datos' },
  { path: '/cita-online/gracias-cita-online/', component: ThankYou, name: 'Gracias' }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Redirige a la ruta del centro si se recarga la página
router.beforeEach((to, from, next) => {
  if (from.fullPath === '/' && (to.fullPath !== '/' && to.fullPath !== '/cita-online/centro/')) {
    console.log('Página recargada, redirigiendo a la raíz');
    next('/cita-online/centro/');
  } else {
    next();
  }
});

export default router;

